import { useTranslation } from "react-i18next";
import UiPageLayout from "../../components/page-layout/PageLayout.component";
import { PageProps } from "../../models/routing.model";
import UiButton from "../../components/button/Button";
import { useNavigate } from "react-router-dom";

const NotFound = (_props: PageProps) => {
	const { t } = useTranslation("common");
	const navigate = useNavigate();

	return (
		<UiPageLayout
			title="NOT_FOUND.TITLE"
			leftChildren={
				<div className="not-found-container">
					<div className="not-found-container__message">
						<span className="not-found-container__message__code">
							{t("NOT_FOUND.CODE")}
						</span>
						<span className="not-found-container__message__msg">
							{t("NOT_FOUND.MESSAGE")}
						</span>
					</div>

					<UiButton
						label="NOT_FOUND.LINK"
						onClick={(_e) => navigate("/", { replace: true })}
					/>
				</div>
			}
		/>
	);
};
export default NotFound;
